export default "__VITE_ASSET__cEC20NUq__"